/**
 * The shared look of the three PUBLIC forms — the pre-interview form, the
 * personal-details form, and the referee's reference form.
 *
 * One copy rather than three identical ones, because these pages are the only
 * part of ServePatch a candidate or a referee ever sees, and three copies drift
 * until the same field looks different depending on which email you followed.
 *
 * MOBILE FIRST, and not as a slogan: most people open an emailed link on a
 * phone, standing up, once. Two things here exist only for that reader:
 *
 *   16px inputs below `sm`. iOS Safari ZOOMS THE PAGE IN whenever a focused
 *   input has text smaller than 16px, and it does not zoom back out — the
 *   candidate is left dragging a form sideways to find the next field. The
 *   14.5px design is kept from `sm` up, where no phone is doing that.
 *
 *   Tighter card padding on a narrow screen. p-7 on a 360px screen spends a
 *   fifth of the width on margins.
 */

export const inputCls = 'w-full px-4 py-3 bg-white dark:bg-[#31373f] dark:text-gray-200 border border-[#E2E8F0] dark:border-gray-700 rounded-xl text-[16px] sm:text-[14.5px] focus:outline-none focus:ring-2 focus:ring-blue-500/10 focus:border-blue-500 transition-all';

export const labelCls = 'block text-[13px] font-semibold text-[#475569] dark:text-gray-400 mb-1.5';

export const cardCls = 'bg-white dark:bg-[#262b33] rounded-2xl border border-[#E3E9F3] dark:border-gray-700 p-5 sm:p-7';
